import cx from "classnames";
import { useAnnotationContext } from "./AnnotationContext.jsx";
import { highlightTypes } from "./annotationCommonPropTypes.js";

import useClickAway from "../../common/useClickAway.js";

import CommentsInterface from "../CommentsInterface/CommentsInterface.jsx";
import Icon from "../Icon/Icon.jsx";

const propTypes = {
  highlightType: highlightTypes,
};

const AnnotationModal = (props) => {
  const {
    data: {
      criteriaUrl,
      content,
      annotationEndPointUrl,
      userIsLoggedIn,
      userEmailAddress,
      itemLink,
      sitecoreItemId,
      annotations,
      selectedContentImage,
    },
    state: { isModalOpen },
    actions: { closeModal },
  } = useAnnotationContext();

  const responsesNumber = annotations ? annotations.length : null;

  const modalRef = useClickAway({ isOpen: isModalOpen, setOpen: closeModal });

  const handleCloseButtonClick = (event) => {
    if (isModalOpen) {
      closeModal();
    }
  };

  const modalClasses = cx("annotation-modal", {
    "annotation-modal--active": isModalOpen,
  });

  return (
    <div ref={modalRef} className={modalClasses}>
      <div className="annotation-modal__modal">
        <div className="annotation-modal__header">
          <button
            type="button"
            className="btn annotation-modal__close-button"
            onClick={handleCloseButtonClick}
            aria-label={content.closeModalLabel}
          >
            <Icon iconName="close-x" />
          </button>
          <div className="annotation-modal__eyebrow">
            {content.selectedContentLabel}
          </div>
          {selectedContentImage ? (
            <div className="annotation-modal__image">
              <img src={selectedContentImage} alt="" />
            </div>
          ) : (
            <div className="annotation-modal__message">
              {content.selectedContentMessage}
            </div>
          )}
        </div>
        <div className="annotation-modal__response-section">
          <CommentsInterface
            submitEndPointUrl={annotationEndPointUrl}
            userIsLoggedIn={userIsLoggedIn}
            criteriaUrl={criteriaUrl}
            replies={annotations}
            parentId={sitecoreItemId}
            itemLink={itemLink}
            userEmailAddress={userEmailAddress}
            responsesNumber={responsesNumber}
            replyDepth={0}
            dictionary={{
              ...content,
              submit: content.submitButtonText,
              cancel: content.cancelButtonText,
              numberResponses: content.annotations,
            }}
          />
        </div>
      </div>
    </div>
  );
};

AnnotationModal.propTypes = propTypes;
export default AnnotationModal;
